import BaseRequest from '@common/services/_baseRequest';


export default {
  getSediAccreditate: (id_comune, id_macrotipologia, cb = null, ecb = null) => {
    var req = new BaseRequest();
    return req.makeRequest(
      {},
      {},
      null,
      'get',
      'affidamento/sede/get-sedi-accreditate/' + id_comune + '/' + id_macrotipologia,
      cb,
      ecb
    );
  },

  getProvinceSediAccreditate: (id_macrotipologia, cb = null, ecb = null) => {
    var req = new BaseRequest();
    return req.makeRequest(
      {},
      {},
      null,
      'get',
      'affidamento/sede/get-province-sedi-accreditate/' + id_macrotipologia,
      cb,
      ecb
    );
  },

  getComuniSediAccreditate: (provincia, id_macrotipologia, cb = null, ecb = null) => {
    var req = new BaseRequest();
    return req.makeRequest(
      {},
      {},
      null,
      'get',
      'affidamento/sede/get-comuni-sedi-accreditate/' + provincia + '/' + id_macrotipologia,
      cb,
      ecb
    );
  },

  getAule: (id_sede, cb = null, ecb = null) => {
    var req = new BaseRequest();
    return req.makeRequest(
      {},
      {},
      null,
      'get',
      'affidamento/sede/' + id_sede + '/get-aule',
      cb,
      ecb
    );
  },

  view: (params, id, cb, ecb = null) => {
		var req = new BaseRequest();
		return req.makeRequest(
			params,
			{},
			null,
			'get',
			'affidamento/sede/' + id,
			cb,
			ecb || null,
			null
		);
	},

}
